import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	DialogActions,
	DialogContent,
	Dialog,
	DialogTitle,
	Grid,
	TextField,
	Typography,
} from "@mui/material";

import { ValidateEmail } from "../Common/helpers";
export default function SellerInviteAmbassadorDialog(props) {
	console.log("SellerInviteAmbassadorDialog",props,props.state.params.deal_uid);
	const handleClose = () => {
		props.onClose();
	};
	const [isDisabled, setIsDisabled] = useState(true);

	const [formData, setFormData] = useState({});
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};
	const handleSubmit = () => {
		console.log("handleSubmit")
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(formData),
		};
		fetch("/api/7dbb451d099a43899ff85f6319cd8d89/" + props.state.params.deal_uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						snack({ o: true, m: "L'invitaton a été envoyée à " + formData.fname, s: "success" });
						
						setTimeout("location.reload(true);", 2000);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	useEffect(() => {
		setIsDisabled(!(ValidateEmail(formData.email) && formData.fname && formData.lname && formData.fname.length > 0 && formData.lname.length > 0));
	}, [formData]);
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Inviter un ambassadeur
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Grid container>
					<Grid item xs={12}>
						<div style="padding-left: 200px; padding-right: 200px; ">
							<Box display="flex" justifyContent="space-between" flexDirection="column" alignItems="flex-start">
								<Box>
									<Typography variant="subtitle2" style="margin-bottom: 20px;">
										Tous les champs sont obligatoires
									</Typography>
								</Box>
								<Box style="width: 100%">
									<TextField
										id="email"
										name="email"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Email de l'ambassadeur en charge du dossier *"
										fullWidth
										margin="dense"
										size="small"
										value={formData.email}
										onChange={handleChange2}
									/>
								</Box>
								<Box style="width: 100%">
									<Grid container spacing={1}>
										<Grid item xs={6}>
											<TextField
												id="fname"
												name="fname"
												variant="outlined"
												style={{
													marginLeft: 0,
													marginRight: 10,
												}}
												placeholder="Prénom *"
												fullWidth
												margin="dense"
												size="small"
												value={formData.fname}
												onChange={handleChange2}
											/>
										</Grid>
										<Grid item xs={6}>
											<TextField
												id="lname"
												name="lname"
												variant="outlined"
												style={{
													marginLeft: 0,
													marginRight: 10,
												}}
												placeholder="Nom *"
												fullWidth
												margin="dense"
												size="small"
												value={formData.lname}
												onChange={handleChange2}
											/>
										</Grid>
									</Grid>
								</Box>
							</Box>
						</div>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Annuler</Button>
				<Button onClick={handleSubmit} variant={"contained"}  disabled={isDisabled}>Inviter</Button>
			</DialogActions>
		</Dialog>
	);
}
